<template>
  <div class="withdraw">
    <el-button type="text" size="medium" @click="$router.go(-1)">返回</el-button><br>
    <el-input class="search-el" size="mini" v-model="query.nickname" clearable placeholder="请输入用户昵称"></el-input>
    <el-input class="search-el" size="mini" v-model="query.user_id" clearable placeholder="请输入用户ID"></el-input>
    <el-select class="search-el" size="mini" v-model="query.target_id" clearable placeholder="课程名称">
      <el-option label="全部" value="">全部</el-option>
      <el-option :label="item.title" :value="item.target_id" v-for=" item in calssArr" :key="item.id">{{ item.title
        }}</el-option>
    </el-select>
    <el-date-picker size="mini" v-model="query.begin_at" type="datetime" placeholder="支付开始日期" @change="changeHandel">
    </el-date-picker>
    ~
    <el-date-picker size="mini" v-model="query.end_at" type="datetime" placeholder="支付结束日期" @change="changeHandel2">
    </el-date-picker>
    <el-select class="search-el" size="mini" v-model="query.rebate_status" clearable>
      <el-option label="全部" value="">全部</el-option>
      <el-option label="分润成功" :value="2">分润成功</el-option>
      <el-option label="分润失败" :value="3">分润失败</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-button type="primary" size="mini" @click="exportList()"> 导出</el-button>
    <div style="color: red; margin: 10px 0;">提示：首页数据默认为今日数据</div>
    <div class="pricebox">
      <div class="item1">
        <div>{{ pageinfo.rebate_amount }}</div>
        <div>发放金额</div>
      </div>
      <div class="item1">
        <div>{{ pageinfo.rebate_user_num }}</div>
        <div>发放人数</div>
      </div>
      <div class="item1">
        <div>{{ pageinfo.rebate_amount_total }}</div>
        <div>活动累计发放金额</div>
      </div>
      <div class="item1" @click="$router.push(`/distribution/purchasepeople?id=${query.activity_distribution_id}`)"
        style="cursor: pointer;">
        <div style="color: #409eff;">{{ pageinfo.rebate_order_num_total }}</div>
        <div style="color: #409eff;">活动累计订单</div>
      </div>
    </div>
    <el-row>
      <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true"
        style="width: 100%; margin: 10px 0">
        <el-table-column label="用户昵称" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div @click.stop="toinfo(row.user_id)" style="color: #409eff;">{{ row.nickname }}</div>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div @click.stop="toinfo(row.user_id)" style="color: #409eff;">{{ row.user_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="课程名称" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div @click="couresinfo(row.target_id)" style="color: #409eff;">{{ row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="获得分润时间" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.payment_at }}</div>
          </template>
        </el-table-column>
        <el-table-column label="活动分润金额" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.amount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="分润状态" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.status_msg }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="bott">
      <el-pagination background layout="prev, pager, next" :total="totalItems" :page-size="pageSize"
        :current-page="currentPage" @current-change="handlePageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getOrderRebateList, getRelationshipList } from "@/api/distribution"
const axios = require('axios');
export default {
  data() {
    return {
      query: {
        activity_distribution_id: this.$route.query.id,
        user_id: '',
        nickname: '',
        target_id: '',
        end_at: '',
        begin_at: '',
        rebate_status: '',
        page: 1,
        limit: 10
      },
      tableData: [],
      currentPage: 1, // 当前页
      pageSize: 10, // 一页几条
      totalItems: 0,
      tableData: [],
      loading: false,
      pageinfo: {},
      page: 1,
      limit: 9999,
      calssArr: []
    }
  },
  mounted() {
    this.getList()
    this.couresHandel()
  },
  methods: {
    getList() {
      getOrderRebateList(this.query).then((res) => {
        console.log(res);
        this.tableData = res.data.list
        this.totalItems = res.data.total
        this.pageinfo = res.data
      })
    },
    derive() { // 导出 

    },
    couresHandel() {
      getRelationshipList({ activity_distribution_id: this.query.activity_distribution_id, page: this.page, limit: this.limit }).then((res) => {
        this.calssArr = res.data.list

      })
    },
    changeHandel(value) {

      this.query.begin_at = this.dateHandel(value)
    },
    changeHandel2(value) {
      this.query.end_at = this.dateHandel(value)
    },
    dateHandel(date) {
      // 使用 Date 对象的方法获取年、月、日
      let year = date.getFullYear();
      let month = date.getMonth() + 1; // 月份从 0 开始，所以要加 1
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      // 将月份和日期转换成两位数的字符串，不足两位的在前面补 0
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      // 将年、月、日拼接成 YYYY-MM-DD 格式的字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    },
    handlePageChange(currentPage) {
      this.query.page = currentPage;
      this.getList()
    },
    exportList() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/activity/distribution/getOrderRebateList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '今日发放金额列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    },
    couresinfo(id) {
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open(`http://dev.admin.defen.hzxinquanzi.com/?c=course&m=course_list&p=31&title=${id}`);
      } else {
        window.open(`http://admin.defen.hzxinquanzi.com/?c=course&m=course_list&p=31&title=${id}`);
        // window.open(`http://dev.admin.defen.hzxinquanzi.com/?c=course&m=course_list&p=31&title=${id}`);
      }
    },
    toinfo(id) {
      this.$router.push({
        path: "/user/info",
        query: {
          id: id,
        }
      });
    },
  },
}
</script>

<style scoped>
.withdraw {
  padding: 10px 20px;
  cursor: pointer;
}

.pricebox {
  display: flex;
  padding: 30px 50px;
  align-items: center;
  justify-content: space-between;
}

.item1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  height: 60px;
  justify-content: space-between;
}
</style>
